import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20 12.75H4a.75.75 0 0 1 0-1.5h16a.75.75 0 1 1 0 1.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m9.445 7.604-.003.002-.01.007-.04.03a31 31 0 0 0-.712.544c-.462.361-1.077.854-1.688 1.385-.616.535-1.212 1.094-1.649 1.588a4.6 4.6 0 0 0-.486.634 1 1 0 0 0-.102.206c.009.027.034.093.102.206q.157.261.486.635c.437.494 1.033 1.052 1.649 1.587a43 43 0 0 0 2.4 1.929l.04.03.01.007.002.002a.75.75 0 0 1-.889 1.208L9 17l-.445.604-.016-.012-.044-.032a36 36 0 0 1-.738-.565 44 44 0 0 1-1.749-1.435c-.634-.55-1.288-1.16-1.789-1.726a6 6 0 0 1-.647-.854c-.156-.26-.322-.607-.322-.98 0-.374.165-.72.322-.98a6 6 0 0 1 .647-.854C4.72 9.6 5.374 8.99 6.01 8.44a44 44 0 0 1 2.487-2l.043-.032.012-.009.004-.003L9 7l-.445-.604a.75.75 0 0 1 .89 1.208",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }